namespace Gamification.Gamification {
    export class ProdottiEsperienzeEditorColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzeEditor';
    }
}
